<template>
  <div class="main-container">
    <div @click="foldBtn(1)" class="foldblock">
      <Icon :type="fold ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
      <span class="title">基本信息</span>
    </div>

    <div class="form-container" v-show="fold">
      <div class="item">
        <span class="label">结算机构：</span>
        <span>{{ infoForm.orgName }}</span>
      </div>

      <div class="item">
        <span class="label">结算周期：</span>
        <span>{{ filter.filterTime(infoForm.settlementDate, 'YYYY-MM-DD') }}</span>
      </div>

      <div class="item-remark" v-if="infoForm.orgIds.includes(userInfo.organId)">
        <span class="label">备注：</span>
        <Input type="textarea" :rows="4" v-model="infoForm.remark" placeholder="请输入" />
      </div>
    </div>

    <Divider />

    <div class="drawBill" id="drawBill" v-if="infoForm.orgIds.includes(userInfo.organId)">
      <div class="drawBillbtn">
        <div @click="foldBtn(2)" class="foldblock">
          <Icon :type="foldData ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
          <span class="title">开票信息</span>
        </div>
        <div class="titleBtn">
          <span>本机构是否已开票</span>
          <i-Switch
            v-model="infoForm.billStatus"
            :disabled="$units.pointAction('offline_82_3_8') ? false : true"
            @on-change="changeStatus($event, 'billStatus')"
            true-value="1"
            false-value="0"
          />
        </div>
      </div>
      <div v-show="foldData">
        <Button type="primary" class="addbtn" @click="addInvoice">新增</Button>
        <Table :columns="invoicetableColumns" :data="invoiceTableData" class="table">
          <template slot-scope="{ row }" slot="billType">
            <span>{{ row.billType == 1 ? '普票' : '专票' }}</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span @click="deleteInvoicetable(row)" class="table-btn">删除</span>
          </template>
        </Table>
      </div>
    </div>
    <Divider v-if="infoForm.orgIds.includes(userInfo.organId)" />

    <div class="drawBill" id="drawBill" v-if="infoForm.orgIds.includes(userInfo.organId)">
      <div class="drawBillbtn">
        <div @click="foldBtn(3)" class="foldblock">
          <Icon :type="foldPay ? 'ios-arrow-down' : 'ios-arrow-up'" class="iconColor" />
          <span class="title">回款信息</span>
        </div>
        <div class="titleBtn">
          <span>本机构是否已回款</span>
          <i-Switch
            v-model="infoForm.refundedStatus"
            :disabled="$units.pointAction('offline_82_3_8') ? false : true"
            @on-change="changeStatus($event, 'refundedStatus')"
            true-value="1"
            false-value="0"
          />
        </div>
      </div>
      <div v-show="foldPay">
        <Button type="primary" class="addbtn" @click="addPay">新增</Button>
        <Table :columns="payColumns" :data="payTableData" class="table">
          <template slot-scope="{ row }" slot="pic">
            <uploadNew :value="[{ path: row.billImages }]" v-if="row.billImages" :isDel="false"></uploadNew>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span @click="deletePaytable(row)" class="table-btn">删除</span>
          </template>
        </Table>
      </div>
    </div>

    <div style="height: 110px"></div>
    <div class="footer-action">
      <div>
        <Button type="primary" class="btn" @click="save" v-if="infoForm.orgIds.includes(userInfo.organId)">保存</Button>
        <Button type="primary" ghost @click="back()">返回</Button>
        <Button type="primary" ghost @click="toBillDetail">查看账单明细</Button>
        <Button type="primary" ghost @click="exportBill">导出账单明细</Button>
      </div>
    </div>
    <div ref="refundedRef"></div>

    <!-- 新增开票 -->
    <addInvoicing ref="invoicingModal" @success="getInvoiceList()"></addInvoicing>

    <!-- 新增回款 -->
    <addPaymentCollection ref="addPay" @success="getPayList()"></addPaymentCollection>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import selectTree from '@/components/system/selectTree3';
import addPaymentCollection from './components/addPaymentCollection';
import addInvoicing from './components/addInvoicing';
import uploadNew from '@/components/commons/uploadNew';

export default {
  mixins: [pageTool, common],
  components: {
    selectTree,
    addPaymentCollection,
    addInvoicing,
    uploadNew
  },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      filter,
      fold: true,
      foldData: true,
      foldPay: true,
      infoForm: {
        settlementDate: '',
        orgIds: []
      },
      invoiceTableData: [],
      invoicetableColumns: [
        {
          title: '发票类型',
          align: 'center',
          slot: 'billType',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '发票代码',
          align: 'center',
          key: 'billCode',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '发票号',
          align: 'center',
          key: 'billNum',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '发票金额',
          align: 'center',
          key: 'billAmount',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '开票人',
          align: 'center',
          key: 'billDrawer',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '开票日期',
          align: 'center',
          key: 'billDate',
          minWidth: 160,
          tooltip: true,
          render(h, params) {
            if (params.row.billDate) {
              const value = filter.filterTime(params.row.billDate, 'YYYY-MM-DD');
              return <span>{value}</span>;
            }
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      payColumns: [
        {
          title: '凭证编号',
          align: 'center',
          key: 'collectionCode',
          minWidth: 150
        },
        {
          title: '收款日期',
          align: 'center',
          key: 'collectionDate',
          minWidth: 150,
          render(h, params) {
            let collectionDate = params.row.collectionDate;
            return <span>{filter.filterTime(collectionDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '回款金额',
          align: 'center',
          key: 'collectionAmount',
          minWidth: 150
        },
        {
          title: '收款账户',
          align: 'center',
          key: 'collectionAccount',
          minWidth: 150
        },
        {
          title: '凭证照片',
          align: 'center',
          width: 200,
          slot: 'pic'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      payTableData: [],
      reportId: null
    };
  },
  created() {
    this.reportId = this.$route.query.reportId;
    let today = new Date();
    this.infoForm.settlementDate = filter.filterTime(today, 'YYYY-MM-DD');
    if (this.reportId) {
      this.searchAjax();
    }
  },
  methods: {
    searchAjax() {
      this.pageNum = 1;
      this.getDetailData();
      this.getInvoiceList();
      this.getPayList();
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/settlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.infoForm = res.data;
        this.infoForm.refundedStatus = !this.infoForm.refundedStatus ? '0' : this.infoForm.refundedStatus;
        this.infoForm.orgName = this.$route.query.orgName;
        if (this.$route.query.roll) {
          this.$nextTick(() => {
            this.$refs.refundedRef.scrollIntoView();
          });
        }
      });
    },

    // 获取发票列表
    getInvoiceList() {
      this.$http({
        url: '/buz/settlementReport/listCheckBill',
        type: 'GET',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.invoiceTableData = res.data;
      });
    },

    // 新增发票
    addInvoice() {
      if (!this.$units.pointAction('offline_82_3_8')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.invoicingModal.open(this.infoForm);
    },

    // 删除发票
    deleteInvoicetable(item) {
      if (!this.$units.pointAction('offline_82_3_8')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: '/buz/settlementReport/delCheckBill?id=' + item.id,
          type: 'delete'
        }).then(res => {
          this.getInvoiceList();
          this.$notice.success('删除成功');
        });
      });
    },

    // 获取回款列表
    getPayList() {
      this.$http({
        url: '/buz/settlementReport/listCheckReturnedMoney',
        type: 'GET',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.payTableData = res.data;
      });
    },

    // 新增回款
    addPay() {
      if (!this.$units.pointAction('offline_82_3_8')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.addPay.open(this.reportId);
    },

    // 删除回款
    deletePaytable(item) {
      if (!this.$units.pointAction('offline_82_3_8')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: '/buz/settlementReport/delCheckReturnedMoney?id=' + item.id,
          type: 'delete'
        }).then(res => {
          this.getPayList();
          this.$notice.success('删除成功');
        });
      });
    },

    // 开票/回款
    changeStatus(value, type) {
      let data = { reportId: this.reportId };
      let url = '';
      if (type == 'billStatus') {
        url = '/buz/settlementReport/invoicing';
        data.status = value;
      } else {
        url = '/buz/settlementReport/returned';
        data.returnedStatus = value;
      }
      this.$http({
        url,
        type: 'POST',
        data
      }).then(res => {
        this.getDetailData();
        this.$notice.success('更改成功');
      });
    },

    // 保存
    save() {
      if (!this.$units.pointAction('offline_82_3_8')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/settlementReport/saveOrgReport',
        type: 'POST',
        data: {
          id: this.reportId,
          type: 3,
          settlementType: this.infoForm.settlementType,
          reportName: this.infoForm.reportName, //结算报表名称
          orgIds: this.infoForm.orgIds, //结算机构id
          settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD'), //结算日期
          remark: this.infoForm.remark //备注
        }
      }).then(res => {
        this.$notice.success('操作成功');
      });
    },

    // 下级机构导出账单明细
    exportBill() {
      if (!this.$units.pointAction('offline_82_3_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/settlementDetails/export', { reportId: this.reportId }, 'POST');
    },

    // 账单明细
    toBillDetail() {
      this.openPageTabTags('/orgSettlement/groupCommissionSettlement/subordinateBillDetail', {
        reportId: this.reportId,
        reportName: this.infoForm.reportName,
        settlementDate: filter.filterTime(this.infoForm.settlementDate, 'YYYY-MM-DD') //结算日期
      });
    },

    // 展开收起
    foldBtn(val) {
      if (val == 1) {
        this.fold = !this.fold;
      } else if (val == 2) {
        this.foldData = !this.foldData;
      } else if (val == 3) {
        this.foldPay = !this.foldPay;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.drawBill {
  margin: 30px 0;
}
.foldblock {
  margin-bottom: 15px;
  display: inline-block;
  cursor: pointer;
  .title {
    font-size: 16px;
    font-weight: 800;
    margin: 0 10px;
    color: #3c464f;
  }
  .iconColor {
    color: #727c8e;
    margin-right: 2px;
  }
}

.form-container {
  display: flex;
  align-items: center;
  padding: 0 30px;
  flex-wrap: wrap;
  .item {
    width: 50%;
    margin-bottom: 20px;
    display: flex;
    .label {
      display: block;
      width: 90px;
      text-align: right;
    }
  }
  .item-remark {
    display: flex;
    width: 100%;
    .label {
      text-align: right;
      width: 90px;
    }
  }
}

.drawBillbtn {
  display: flex;
  align-items: center;
  line-height: 24px;
  margin-bottom: 10px;
  span {
    margin-right: 10px;
  }
  .titleBtn {
    margin-left: 20px;
    margin-bottom: 16px;
  }
}
.addbtn {
  min-width: 80px;
  margin-bottom: 20px;
  margin-left: 30px;
}
.table {
  margin-bottom: 30px;
}
.footer-action {
  position: fixed;
  bottom: 0px;
  background: #fff;
  z-index: 1;
  width: 98%;
  height: 120px;
  line-height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
</style>
